
  <div class="row my-5">
    <div class="col-md-4 text-center">
      <img src="assets/images/Facebook_default_male_avatar.gif" class="avatar mb-3">
      <h3>The Adventurer</h3>
      <p>
        Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat.
      </p>
      <p><a class="btn btn-outline-primary" routerLink="/book/adventurer">Begin Exploring</a></p>
    </div>
    <div class="col-md-4 text-center">
      <img src="assets/images/Facebook_default_female_avatar.gif" class="avatar mb-3">
      <h3>The Honeymooner</h3>
      <p>
        Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat.
      </p>
      <p><a class="btn btn-outline-primary" routerLink="/book/honeymooner">Spice It Up</a></p>
    </div>
    <div class="col-md-4 text-center">
      <img src="assets/images/Facebook_default_male_avatar.gif" class="avatar mb-3">
      <h3>The Business Traveler</h3>
      <p>
        Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat.
      </p>
      <p><a class="btn btn-outline-primary" routerLink="/book/business">Plan Your Trip</a></p>
    </div>
</div>
